import * as ValueTypeKeys from 'automation-ui-action-features/actions/extension/generic-extension/ValueTypeKeys';
export const getValueTypeFromFieldDefinition = inputField => {
  if (inputField.typeDefinition.fieldType === 'checkbox') {
    return ValueTypeKeys.MULTI;
  } else if (inputField.typeDefinition.optionsUrl) {
    return ValueTypeKeys.EXTERNAL;
  } else if (inputField.supportedValueTypes && inputField.supportedValueTypes[0] === 'OBJECT_PROPERTY') {
    return ValueTypeKeys.PROPERTY;
  } else {
    return ValueTypeKeys.STATIC;
  }
};